import React, { useContext } from 'react';
import _get from 'lodash/get';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { isGramicci } from 'utils/retailer';
import { useLoginLayout } from 'utils/hooks';
import { withLoginLayout } from 'components';
import { Form } from './components';
import { Logo } from 'views/Templates/Store';
import { AuthContext } from 'context/AuthContext';
import { DEMO_APP_DETAILS } from './stubs';

function randomIntBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function Login() {
  const { serviceCopies, isDemoApp } = useContext(AuthContext);
  const { isTemplateTwo } = useLoginLayout();

  const heading = _get(serviceCopies, 'LOGIN_HEADING', '');
  const LoginEmail = DEMO_APP_DETAILS.LOGIN_EMAIL;
  const LoginOrderId = DEMO_APP_DETAILS.LOGIN_ORDERS[randomIntBetween(0, 6)];

  return (
    <>
      <If test={isDemoApp}>
        <p className="mb-4">
          Please use the following details to login for a demo <br />
          Email: <b>{LoginEmail}</b> <br />
          Order Number: <b>{LoginOrderId}</b>
        </p>
      </If>
      <If test={isTemplateTwo}>
        <Logo />
      </If>
      <div className={styles.content}>
        <div className={cn('FormWrapper__heading', styles.title)}>
          {heading}
        </div>
        <If test={isGramicci()}>
          <p className={cn('FormWrapper__description', styles.description)}>
            If you are returning and exchanging items in the same order, please
            submit separately to expedite the process.
          </p>
        </If>
      </div>
      <Form />
    </>
  );
}

export default withLoginLayout(Login);
